import moment from "moment";

export const dateFormat = (date) => moment.unix(date).format("DD-MM-YYYY");
